/**
 * Created by or_p on 10/8/2016.
 */
import _ from 'lodash';

// clip board can't be accessed from javascript when there is no native paste event;
const VIRTUAL_CLIPBOARD = 'virtualClipboard';

export function getVirtualClipBoardContent() {
  try {
    const clipboardContent = window.localStorage.getItem(VIRTUAL_CLIPBOARD);
    if (_.isEmpty(clipboardContent)) {
      return null;
    }
    const {data, expire} = JSON.parse(clipboardContent);
    if (expire > (new Date().getTime())) {
      return data;
    }
  } catch (e) {
    console.warn('Virtual clipboard data is invalid');
  }
  return null;
}

export function isVirtualClipBoardEmpty() {
  return _.isEmpty(getVirtualClipBoardContent());
}

export function setVirtualClipboardContent(data) {
  window.localStorage.setItem(VIRTUAL_CLIPBOARD, JSON.stringify({data, expire: (new Date().getTime() + 1000 * 60 * 5)}));
}
